
import { get, getById } from "@/utilities/querySelector";
import { toggleScroll } from "@/utilities/toggleScroll";


const header = document.getElementById( 'site-header' );
const mobileMenuToggle = document.getElementById( 'mobile-menu-toggle' );
const mobileMenu = document.getElementById( 'mobile-menu' );
const search = getById( 'site-product-search' );
const searchClose = getById( 'site-product-search-close' );
const searchOpen = getById( 'site-product-search-toggle' );

mobileMenuToggle?.addEventListener( 'click', () => {
    toggleMenu( 'mobile' );
} );

mobileMenu?.querySelectorAll( 'a' ).forEach( link => {
    link.addEventListener( 'click', () => {
        closeMenus();
    } );
} );

searchOpen?.addEventListener( 'click', () => {
    closeMenus();
    const scroll = window.scrollY;
    requestAnimationFrame( () => window.scrollTo( { top: scroll } ) );
} );

searchClose?.addEventListener( 'click', () => {
    const scroll = window.scrollY;
    requestAnimationFrame( () => window.scrollTo( { top: scroll } ) );
} );

search?.addEventListener( 'keyup', ( e ) => {
    if ( e.code !== 'Escape' ) return;
    location.hash = '';
    searchOpen.focus();
} );


/**
 * @param {string} menu Then menus name
 *
 * @return void
 */
function toggleMenu( menu ) {
    if ( header?.getAttribute( 'data-menu-active' ) === menu ) {
        closeMenus();
    } else {
        openMenu( menu );
    }
}

/**
 * Opens the specified header menu
 *
 * @param {string} menu
 *
 * @return void
 */
function openMenu( menu ) {
    header?.setAttribute( 'data-menu-active', menu );
    toggleScroll( false );
}

/**
 * Closes all the header menus
 *
 * @return void
 */
function closeMenus() {
    header?.removeAttribute( 'data-menu-active' );
    toggleScroll( true );
}

/**
 * Using intersection observer is way more efficient than adding a scroll listener for this task
 */
const scrollIndicator = document.getElementById( 'site-header-scroll-indicator' );
if ( header && scrollIndicator ) {
    const scrollDeterminer = new IntersectionObserver( headerScrollHandler, {} );
    scrollDeterminer.observe( scrollIndicator );
}

/**
 * @param {IntersectionObserverEntry[]} entries
 *
 * @return void
 */
function headerScrollHandler( entries ) {
    entries.forEach( entry => {
        header?.toggleAttribute( 'data-scrolled', !entry.isIntersecting );
    } );
}


/**
 * Category menu sub menu dropdown placement
 */
const submenus = header?.querySelectorAll( '.category-menu .menu-item-has-children' );
submenus?.forEach( item => {
    item.addEventListener( 'mouseenter', assignSubmenuOffset );
} );

/**
 *
 * @param {MouseEvent} e The currentTarget property should be a menu item with a sub-menu
 *
 * @return void
 */
function assignSubmenuOffset( e ) {
    const item = /** @type {HTMLLIElement} */ ( e.currentTarget );
    const menu = item.closest( 'nav' );

    const scrollX = menu?.scrollLeft ?? 0;
    item.style.setProperty( '--submenu-scroll-offset', `-${scrollX}px` );
}


/**
 * Dumb fix for dumb problem where typing in the search field causes the entire page to scroll up due to the scroll-padding-top.
 */
const searchInput = get( '.search-form-field' );
searchInput?.addEventListener( 'keydown', ( e ) => {
    const scroll = window.scrollY;
    requestAnimationFrame( () => window.scrollTo( { top: scroll } ) );
} );